import { api } from '@/lib/api'
import type { ProfitTakingResponse } from '@/types/profitTaking'

export async function listProfitTaking(): Promise<ProfitTakingResponse> {
  const { data } = await api.get<ProfitTakingResponse>('/profit-taking/')
  return data
}

export async function topProfitTaking(limit = 3): Promise<ProfitTakingResponse> {
  const { data } = await api.get<ProfitTakingResponse>('/profit-taking/top', {
    params: { limit },
  })
  return data
}
